// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-item__contact-info-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: left;
}

.contact-item__contact-avatar {
    border-radius: 50%;
    margin-right: 1.5rem;
    margin-left: 1.5rem;
    box-shadow: 0px 0px 2px 0px #fff;
    width: 5rem !important;
    height: 5rem !important;
}

    .contact-item__contact-avatar svg {
        width: 100% !important;
        height: 100% !important;
    }

.contact-item__contact-info {
    display: flex;
    flex-direction: column;
}

.contact-item__table-row {
    transition: 0.4s;
    cursor: pointer;
}

.contact-item__table-row:hover {
    transition: 0.1s;
    box-shadow: 0px 0px 8px 0px #26a69a;
}

.contact-item__contact-info-cell {
    width: 30rem;
    min-width: 15rem;
    overflow: hidden;
    text-overflow: ellipsis;
}

.contact-item__messengers {
    max-width: 15rem;
}

.contact-item__creation-date {
    width: 15rem;
    min-width: 10rem;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
}

.contact-item__chats-count {
    width: 10rem;
    min-width: 10rem;
    overflow: hidden;
    text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/app/contact/contact-main/contact-list/contact-item/ContactItem.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,gCAAgC;IAChC,sBAAsB;IACtB,uBAAuB;AAC3B;;IAEI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;AAEJ;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B","sourcesContent":[".contact-item__contact-info-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    text-align: left;\r\n}\r\n\r\n.contact-item__contact-avatar {\r\n    border-radius: 50%;\r\n    margin-right: 1.5rem;\r\n    margin-left: 1.5rem;\r\n    box-shadow: 0px 0px 2px 0px #fff;\r\n    width: 5rem !important;\r\n    height: 5rem !important;\r\n}\r\n\r\n    .contact-item__contact-avatar svg {\r\n        width: 100% !important;\r\n        height: 100% !important;\r\n    }\r\n\r\n.contact-item__contact-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.contact-item__table-row {\r\n    transition: 0.4s;\r\n    cursor: pointer;\r\n}\r\n\r\n.contact-item__table-row:hover {\r\n    transition: 0.1s;\r\n    box-shadow: 0px 0px 8px 0px #26a69a;\r\n}\r\n\r\n.contact-item__contact-info-cell {\r\n    width: 30rem;\r\n    min-width: 15rem;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.contact-item__messengers {\r\n    max-width: 15rem;\r\n}\r\n\r\n.contact-item__creation-date {\r\n    width: 15rem;\r\n    min-width: 10rem;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    text-align: center;\r\n}\r\n\r\n.contact-item__chats-count {\r\n    width: 10rem;\r\n    min-width: 10rem;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
